import { Modal, TextTitle, Stack, Spacer } from '@pypestream/design-system';
import { FC } from 'react';

import { ProductCTA } from '../../product-cta';
import { ManagerContext } from '../../../xstate/manager.xstate.types';
import { ProductName } from '@pypestream/api-services';
import { useTranslation } from '@pypestream/translations';

interface ProductCardsModalProps {
  open: boolean;
  project?: NonNullable<ManagerContext['projectsNew']>[number];
  onClose: () => void;
}

export const ProductCardsModal: FC<ProductCardsModalProps> = ({
  open,
  project,
  onClose,
}) => {
  const [t] = useTranslation();

  return (
    <Modal open={open} size="large" onClose={onClose}>
      <div slot="header">
        <Spacer size="medium"></Spacer>
        <TextTitle slot="header" size="xsmall" textAlign="center">
          {t('manager/common:products.selectToolToView', {
            projectName: project?.name || '',
          })}
        </TextTitle>
      </div>
      <Spacer size="medium"></Spacer>
      <Stack justifyContent="center" gutter="large">
        {project?.conditionalProducts
          ?.filter(
            ({ name }: { name: ProductName | 'Studio' }) => name !== 'Studio'
          )
          .map(({ url, logo, label, productId, disabled }, index) => {
            return (
              <ProductCTA
                url={url}
                logo={logo}
                name={label}
                key={productId || index}
                disabled={disabled}
                // style={{ maxWidth: 146 }}
              />
            );
          })}
      </Stack>
      <Spacer size="medium"></Spacer>
    </Modal>
  );
};
